export default "__VITE_ASSET__P9i6w1fX__"